import { render, staticRenderFns } from "./GoogleAdsBidModal.vue?vue&type=template&id=6a5158ca"
import script from "./GoogleAdsBidModal.vue?vue&type=script&lang=js"
export * from "./GoogleAdsBidModal.vue?vue&type=script&lang=js"
import style0 from "./GoogleAdsBidModal.vue?vue&type=style&index=0&id=6a5158ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports